module.exports = __webpack_public_path__ + "static/media/ic-arrow-top-right.2933f821.svg";